import CourierStoresRepository from './CourierStoresRepository';

export default CourierStoresRepository;
